export class OrganizationInviteAlreadyAcceptedError extends Error {
  constructor(message: string) {
    super(message)
    Object.setPrototypeOf(this, OrganizationInviteAlreadyAcceptedError.prototype)
  }
}
